var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMoveArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.03,3.62H16.26c-1.11,0-2,.89-2,2v4.06c0,1.11,.89,2,2,2s2-.89,2-2v-2.06h21.78V29.4h-1.97c-1.11,0-2,.89-2,2s.89,2,2,2h3.97c1.11,0,2-.89,2-2V5.62c0-1.11-.89-2-2-2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.74,36.31c-1.11,0-2,.89-2,2v2.06H7.97V18.6h1.97c1.11,0,2-.89,2-2s-.89-2-2-2h-3.97c-1.11,0-2,.89-2,2v25.77c0,1.11,.89,2,2,2H31.74c1.11,0,2-.89,2-2v-4.06c0-1.11-.89-2-2-2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.31,34.41l13.3-13.3v10.35c0,1.1,.89,2,2,2s2-.89,2-2v-14.95c0-.2-.04-.4-.1-.58-.08-.37-.26-.72-.54-1-.29-.29-.64-.46-1-.54-.19-.06-.38-.1-.58-.1h-14.95c-1.1,0-2,.89-2,2s.89,2,2,2h10.35l-13.3,13.3c-.78,.78-.78,2.05,0,2.83s2.05,.78,2.83,0Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoveArticle);
export default __webpack_public_path__ + "static/media/ico-move-article.757bebb66b4ac8abd4e976159945da14.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;